<button mat-icon-button [matMenuTriggerFor]="menu" color="accent">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button
          [matTooltipPosition]="'above'"
          mat-menu-item
          matTooltip="Edition des options"
          (click)="fieldActions('edit')"
  >
    <mat-icon color="accent">mode_edit</mat-icon>
    <span>Modifier</span>
  </button>
  <button
          [matTooltipPosition]="'above'"
          mat-menu-item
          matTooltip="Enlever ce champ"
          (click)="fieldActions('delete')"
  >
    <mat-icon color="warn">close</mat-icon>
    <span>Supprimer</span>
  </button>
</mat-menu>

